<app-global-loading *ngIf="loading"></app-global-loading>
<app-workorder-tip [flag]="flag"></app-workorder-tip>

<div
  class="modal-overlay"
  *ngIf="showServiceModal"
  (click)="closeServiceModal()"
>
  <div class="modal-container" (click)="$event.stopPropagation()">
    <button
      class="modal-close"
      type="button"
      (click)="closeServiceModal()"
      aria-label="关闭"
    >
      ×
    </button>

    <div class="modal-header">
      <h2>服务体验升级通知</h2>
    </div>

    <div class="feature-list">
      <div class="feature-item">
        <h3>认准右下角，一键唤醒服务</h3>
        <p>
          为提升效率，原「手动提交工单」入口现已关闭。现在只需点击网站右下角的
          <span class="highlight-icon">蓝色小圆圈</span>，即可直接与 AI
          客服对话，沟通如聊天般简单。
        </p>
      </div>

      <div class="feature-item">
        <h3>工单进度，依然一目了然</h3>
        <p>
          不用担心进度迷失，您随时可以前往原工单页面，清晰查看所有问题的最新处理状态与解决方案。
        </p>
      </div>
    </div>

    <div class="summary-box">
      <p>
        <strong>一句话总结：</strong><br />
        沟通问题请找右下角<span class="brand-text">蓝色 AI 客服</span><br />
        查看进度请前往<span class="brand-text">原工单页面</span>。
      </p>
    </div>

    <div class="modal-footer">
      <button class="btn-confirm" type="button" (click)="closeServiceModal()">
        我知道了
      </button>
    </div>
  </div>
</div>

<div class="card">
  <div class="list">
    <div class="title">
      <div class="left">
        我的工单
        <!-- <span>({{ list?.length }})</span> -->
      </div>
      <div class="right">
        <button matRipple (click)="newWorkorder()">新建工单</button>
      </div>
    </div>
    <div class="search">
      <!-- <app-workorder-card-search
        placeholder="查找工单"
        (input)="onInputChange($event)"
      ></app-workorder-card-search> -->
      <div
        class="status-tab"
        [ngClass]="{
          active: hasStatus('NoResponseReceived'),
        }"
        (click)="changeStatusTab('NoResponseReceived')"
      >
        新建
      </div>
      <div
        class="status-tab"
        [ngClass]="{
          active: hasStatus('ReplyReceived'),
        }"
        (click)="changeStatusTab('ReplyReceived')"
      >
        等待您的回复
      </div>
      <div
        class="status-tab"
        [ngClass]="{
          active: hasStatus('ProactiveCompletion'),
        }"
        (click)="changeStatusTab('ProactiveCompletion')"
      >
        已完结
      </div>
    </div>
    <div class="items">
      <ng-container *ngIf="list?.length !== 0">
        <app-workorder-card
          *ngFor="let item of list"
          [data]="item"
          (click)="changeDetail(item)"
        ></app-workorder-card>
      </ng-container>
      <ng-container *ngIf="list?.length === 0">
        <div class="no-data">
          <svg viewBox="0 0 160 160">
            <defs>
              <linearGradient x1="50%" x2="50%" y2="100%" id="van-empty-1-5">
                <stop stop-color="#F2F3F5" offset="0%"></stop>
                <stop stop-color="#DCDEE0" offset="100%"></stop>
              </linearGradient>
              <linearGradient
                x1="95%"
                y1="48%"
                x2="5.5%"
                y2="51%"
                id="van-empty-1-6"
              >
                <stop stop-color="#EAEDF1" offset="0%"></stop>
                <stop stop-color="#DCDEE0" offset="100%"></stop>
              </linearGradient>
              <linearGradient y1="45%" x2="100%" y2="54%" id="van-empty-1-7">
                <stop stop-color="#EAEDF1" offset="0%"></stop>
                <stop stop-color="#DCDEE0" offset="100%"></stop>
              </linearGradient>
            </defs>
            <defs>
              <linearGradient id="van-empty-1-a" x1="64%" y1="100%" x2="64%">
                <stop stop-color="#FFF" offset="0%" stop-opacity="0.5"></stop>
                <stop stop-color="#F2F3F5" offset="100%"></stop>
              </linearGradient>
            </defs>
            <g opacity=".8">
              <path
                d="M36 131V53H16v20H2v58h34z"
                fill="url(#van-empty-1-a)"
              ></path>
              <path
                d="M123 15h22v14h9v77h-31V15z"
                fill="url(#van-empty-1-a)"
              ></path>
            </g>
            <defs>
              <linearGradient
                id="van-empty-1-b"
                x1="64%"
                y1="97%"
                x2="64%"
                y2="0%"
              >
                <stop
                  stop-color="#F2F3F5"
                  offset="0%"
                  stop-opacity="0.3"
                ></stop>
                <stop stop-color="#F2F3F5" offset="100%"></stop>
              </linearGradient>
            </defs>
            <g opacity=".8">
              <path
                d="M87 6c3 0 7 3 8 6a8 8 0 1 1-1 16H80a7 7 0 0 1-8-6c0-4 3-7 6-7 0-5 4-9 9-9Z"
                fill="url(#van-empty-1-b)"
              ></path>
              <path
                d="M19 23c2 0 3 1 4 3 2 0 4 2 4 4a4 4 0 0 1-4 3v1h-7v-1l-1 1c-2 0-3-2-3-4 0-1 1-3 3-3 0-2 2-4 4-4Z"
                fill="url(#van-empty-1-b)"
              ></path>
            </g>
            <g transform="translate(36 50)" fill="none">
              <g transform="translate(8)">
                <rect
                  fill="#EBEDF0"
                  opacity=".6"
                  x="38"
                  y="13"
                  width="36"
                  height="53"
                  rx="2"
                ></rect>
                <rect
                  fill="url(#van-empty-1-5)"
                  width="64"
                  height="66"
                  rx="2"
                ></rect>
                <rect
                  fill="#FFF"
                  x="6"
                  y="6"
                  width="52"
                  height="55"
                  rx="1"
                ></rect>
                <g transform="translate(15 17)" fill="url(#van-empty-1-6)">
                  <rect width="34" height="6" rx="1"></rect>
                  <path d="M0 14h34v6H0z"></path>
                  <rect y="28" width="34" height="6" rx="1"></rect>
                </g>
              </g>
              <rect
                fill="url(#van-empty-1-7)"
                y="61"
                width="88"
                height="28"
                rx="1"
              ></rect>
              <rect
                fill="#F7F8FA"
                x="29"
                y="72"
                width="30"
                height="6"
                rx="1"
              ></rect>
            </g>
          </svg>
          <div>暂无数据</div>
        </div>
      </ng-container>
    </div>
    <div
      class="wechat"
      (click)="openWechatModal()"
      *ngIf="!this.self?.publicid"
    >
      <img src="../../../../assets/images/workorder/wechat.png" alt="" />
      <span>点击绑定公众号<br />实时接收工单回复</span>
    </div>
  </div>
  <div class="divider"></div>
  <div class="detail">
    <router-outlet></router-outlet>
  </div>
</div>
